{
    "Presence_Page_Title": "Anwesenheit",
    "Presence_SortBy_Title": "Sortieren nach:",
    "Presence_SortBy_Options_FullName_ASC": "Vollständiger Name (A-Z)",
    "Presence_SortBy_Options_FullName_DSC": "Vollständiger Name (Z-A)",
    "Presence_Search_Title": "Suche",
    "Presence_Filter_Title": "Mehr Filter",
    "Presence_MoreFilters_Title": "Filtern nach:",
    "Presence_MoreFilters_Options_Department": "Abteilung",
    "Presence_MoreFilters_Options_Queue": "Warteschlange",
    "Presence_Filter_Availability_All": "Alle",
    "Presence_Filter_Availability_Available": "Verfügbar",
    "Presence_Filter_Availability_Busy": "Beschäftigt",
    "Presence_Filter_Availability_Away": "Auswärts",
    "Presence_Filter_Availability_Offline": "Offline",
    "Presence_Filter_Availability_OutOfOffice": "Nicht im Amt",
    "Presence_Filter_Availability_DoNotDisturb": "Bitte nicht stören",
    "Presence_Filter_Availability_BeRightBack": "Bin gleich zurück",
    "Presence_Activity_Available_Title": "Verfügbar",
    "Presence_Activity_Away_Title": "Auswärts",
    "Presence_Activity_BeRightBack_Title": "Bin gleich zurück",
    "Presence_Activity_Busy_Title": "Beschäftigt",
    "Presence_Activity_DoNotDisturb_Title": "Bitte nicht stören",
    "Presence_Activity_InAcall_Title": "Bei einem Anruf",
    "Presence_Activity_InAConferenceCall_Title": "In einer Telefonkonferenz",
    "Presence_Activity_Inactive_Title": "Inaktiv",
    "Presence_Activity_InAMeeting_Title": "In einer Sitzung",
    "Presence_Activity_Offline_Title": "Offline",
    "Presence_Activity_OffWork_Title": "Feierabend",
    "Presence_Activity_OutOfOffice_Title": "Nicht im Amt",
    "Presence_Activity_PresenceUnknown_Title": "Anwesenheit Unbekannt",
    "Presence_Activity_Presenting_Title": "Präsentieren",
    "Presence_Activity_UrgentInterruptionsOnly_Title": "Nur dringende Unterbrechungen",
    "Presence_NoUsers": "Für Ihren aktuellen Filter sind keine Benutzer verfügbar",
    "NAME": "Presence",
    "Presence_Activity_InACall_Title": "Bei einem Anruf",
    "Presence_SearchQuery_TooLong": "Die Suche ist zu lang"
}